import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getClientToken } from "./clientAuth";

const AUTH_EVENT = "payways:auth-change";
export const emitAuthChange = () => window.dispatchEvent(new Event(AUTH_EVENT));

export default function useAuth() {
  const reduxAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const [token, setToken] = useState(() => getClientToken());
  useEffect(() => {
    const sync = () => setToken(getClientToken());
    window.addEventListener(AUTH_EVENT, sync);
    window.addEventListener("focus", sync);
    return () => { window.removeEventListener(AUTH_EVENT, sync); window.removeEventListener("focus", sync); };
  }, []);
  return { token, isAuthenticated: reduxAuthenticated || Boolean(token) };
}
